import { render, staticRenderFns } from "./video.vue?vue&type=template&id=23e3b06a&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3b06a",
  null
  
)

export default component.exports